import {MembersPageState} from '../types/state'

export const getCurrentTab = (state: MembersPageState) => state.tab
